import { useState } from 'react'
import { NeoComponents, calcScopePermission } from "@forcepoint/platform-utilityui"
import AlertsDropdown from './AlertsDropdown'

const theme = NeoComponents.NeoTheme

const NotificationAction = ({ stateData, setCurrentDropdown, currentDropdown }) => {
  const activeApp = stateData?.activeApp
  const userInfo = stateData?.userInfo
  const alertPermissions = userInfo && calcScopePermission("idm.alert")

  const [alertsCount, setAlertsCount] = useState<number>(0)

  return activeApp?.modules?.uiConfig?.enableNotifications &&
    (alertPermissions?.read || alertPermissions?.readOnly) && (
      <li className="shell-dropdown-container notification-dropdown">
        <a
          id="alert_link"
          onKeyDown={() => {}}
          onClick={(e) => {
            e.preventDefault()
            setCurrentDropdown("alert")
          }}
          className="pos-relative"
        >
          <NeoComponents.NeoIcon
            name="bell"
            size={18}
            data-always="true"
            data-dark-tip="Notifications"
          />
          {alertsCount > 0 && (
            <span className="indicator">{alertsCount}</span>
          )}
        </a>

        <div
          className={
            "shell-dropdown notification-dropdown-menu " +
            (currentDropdown === "alert" ? "show" : "")
          }
          style={{ padding: 0, overflow: "hidden" }}
        >
          {/* Header — fixed, not scrollable */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: `1px solid ${theme.neutral.brightGray}`
          }}>
            <NeoComponents.NeoText
              fs={14}
              fw={theme.fontWeight.demiBold}
              color={theme.neutral.darkSlate}
            >
              Notifications
            </NeoComponents.NeoText>
            {alertsCount > 0 && (
              <span style={{
                background: theme.primaryBrand.teal25,
                color: theme.primaryBrand.teal450,
                borderRadius: 12,
                padding: "2px 8px",
                fontSize: 11,
                fontWeight: theme.fontWeight.demiBold
              }}>
                {alertsCount}
              </span>
            )}
          </div>

          {/* Scrollable alerts list */}
          <div style={{
            maxHeight: "60vh",
            overflowY: "auto",
            overflowX: "hidden"
          }}>
            <AlertsDropdown
              userToken={stateData?.userToken}
              activeApp={activeApp}
              setAlertsCount={setAlertsCount}
            />
          </div>
        </div>
      </li>
    )
}

export default NotificationAction
